export default __webpack_public_path__ + "static/media/popup_back.e72410b8.svg";